/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/array/from.js
 ** module id = 1275
 ** module chunks = 0
 **/